import { render } from "./Testimonial.vue?vue&type=template&id=2b08a1e2&scoped=true"
import script from "./Testimonial.vue?vue&type=script&lang=js"
export * from "./Testimonial.vue?vue&type=script&lang=js"

import "./Testimonial.vue?vue&type=style&index=0&id=2b08a1e2&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b08a1e2"]])

export default __exports__